import dayjs from 'dayjs';
import dayjsUtc from 'dayjs/plugin/utc';
import moment from 'moment';
//Types
import {
  GetCampaignOffers_getCampaignOffers_entities,
  GetCampaignOffers_getCampaignOffers_entities_campaign_activities_SocialActivity_tasks,
  GetCampaignOffers_getCampaignOffers_entities_deliverables_items,
  GetCampaignOffers_getCampaignOffers_entities_deliverables_items_CBDeliverableCopy,
  GetCampaignOffers_getCampaignOffers_entities_deliverables_items_CBDeliverableFileItem,
  GetCampaignOffers_getCampaignOffers_entities_deliverablesV2,
  GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items,
  GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableCopyV2,
  GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFileItemV2,
  GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFileItemV2_task_CampaignContentTask,
  GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFilesItemV2,
  GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_task,
  GetCampaignOffers_getCampaignOffers_entities_submissions,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignFBShareSubmission,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignIGLiveSubmission,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignIGPostSubmission,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignIGReelSubmission,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignIGShareSubmission,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignIGStorySubmission,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignLiveAppearanceSubmission,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignRecordedAppearanceSubmission,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignTTShareSubmission,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignTTVideoSubmission,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignTWShareSubmission,
  GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignYTShareSubmission,
} from 'api/campaignV2/types/GetCampaignOffers';
import {
  CampaignOfferSubmissionInput,
  CampaignTaskType,
  CampaignType,
  CBDeliverableItemType,
  CreateCampaignTaskInput,
  CreateCampaignTaskV2Input,
  CreateCampaignContentTaskInput,
  CbDeliverableV2Status,
  CbDeliverableItemV2Status,
  CampaignMediaType,
  CbDueDateType,
  CbFixedDateType,
} from 'api/graphql-global-types';
import { isCustomLikeCampaign } from 'helpers/campaign';
import { UploadImage } from 'ui/UploadMultipleImages/UploadMultipleImages';
import { PresignedUrlResultItem } from './single-uploader';
import {
  GetCampaignsV2_getCampaigns_entities_activities_SocialActivity_tasks,
  GetCampaignsV2_getCampaigns_entities_activities_SocialActivity_tasksV2,
} from 'api/campaignV2/types/GetCampaignsV2';
import { DELIVERABLES_TIMELINE_CARDS_MAX_SLOTS } from 'constants/deliverables';

dayjs.extend(dayjsUtc);

export type SocialStateType = {
  iGPosts: string[];
  iGReels: string[];
  tikToks: string[];
  storyImages: UploadImage[];
  liveImages: UploadImage[];
  twitterTweets: string[];
  twitterVideos: string[];
  twitterLives: string[];
};

export enum SocialStateEnum {
  iGPosts = 'iGPosts',
  iGReels = 'iGReels',
  tikToks = 'tikToks',
  storyImages = 'storyImages',
  liveImages = 'liveImages',
  twitterTweets = 'twitterTweets',
  twitterVideos = 'twitterVideos',
  twitterLives = 'twitterLives',
}

export const EMPTY_SOCIAL_STATE: SocialStateType = {
  iGPosts: [],
  iGReels: [],
  tikToks: [],
  storyImages: [],
  liveImages: [],
  twitterTweets: [],
  twitterVideos: [],
  twitterLives: [],
};

export type SocialSubmissions =
  | GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignIGReelSubmission
  | GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignIGPostSubmission
  | GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignTTVideoSubmission;

export type DeliverableV2 =
  | GetCampaignsV2_getCampaigns_entities_activities_SocialActivity_tasks
  | CreateCampaignTaskInput;

export type TimeLineDeliverable =
  | GetCampaignsV2_getCampaigns_entities_activities_SocialActivity_tasksV2
  | CreateCampaignTaskV2Input
  | CreateCampaignContentTaskInput;

export const getInitialSocialState = (
  record: GetCampaignOffers_getCampaignOffers_entities | null
): SocialStateType => {
  const submissions = record?.submissions || [];
  const storySubmissions: UploadImage[] = [];
  const liveSubmissions: UploadImage[] = [];
  (
    submissions as GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignIGStorySubmission[]
  ).forEach((item) => {
    if (item.type === CampaignTaskType.IG_STORY) {
      storySubmissions.push({
        data_url: item.url,
        data_key: item.imageKey,
        file: undefined,
      });
    }
  });

  (
    submissions as GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignIGLiveSubmission[]
  ).forEach((item) => {
    if (item.type === CampaignTaskType.IG_LIVE) {
      liveSubmissions.push({
        data_url: item.url,
        data_key: item.imageKey,
        file: undefined,
      });
    }
  });

  const postSubmissions: string[] = [];
  const reelSubmissions: string[] = [];
  const tikTokSubmissions: string[] = [];
  const twitterTweetsSubmissions: string[] = [];
  const twitterVideosSubmissions: string[] = [];
  const twitterLivesSubmissions: string[] = [];

  (submissions as SocialSubmissions[]).forEach((item) => {
    if (item.type === CampaignTaskType.IG_POST) {
      postSubmissions.push(item.link);
    }
    if (item.type === CampaignTaskType.IG_REEL) {
      reelSubmissions.push(item.link);
    }
    if (item.type === CampaignTaskType.TT_VIDEO) {
      tikTokSubmissions.push(item.link);
    }
    if (item.type === CampaignTaskType.TW_TWEET) {
      twitterTweetsSubmissions.push(item.link);
    }
    if (item.type === CampaignTaskType.TW_VIDEO) {
      twitterVideosSubmissions.push(item.link);
    }
    if (item.type === CampaignTaskType.TW_LIVE) {
      twitterLivesSubmissions.push(item.link);
    }
  });

  const result: SocialStateType = {
    storyImages: storySubmissions,
    liveImages: liveSubmissions,
    iGPosts: postSubmissions.length ? postSubmissions : [''],
    iGReels: reelSubmissions.length ? reelSubmissions : [''],
    tikToks: tikTokSubmissions.length ? tikTokSubmissions : [''],
    twitterTweets: twitterTweetsSubmissions.length
      ? twitterTweetsSubmissions
      : [''],
    twitterVideos: twitterVideosSubmissions.length
      ? twitterVideosSubmissions
      : [''],
    twitterLives: twitterLivesSubmissions.length
      ? twitterLivesSubmissions
      : [''],
  };

  return result;
};

export const arrangeSubmissions = (
  state: SocialStateType,
  imageKeys: PresignedUrlResultItem[]
): CampaignOfferSubmissionInput[] => {
  const result: CampaignOfferSubmissionInput[] = [];

  state.liveImages.forEach((image) => {
    result.push({
      imageKey: image.file
        ? imageKeys.shift()?.key || ''
        : image.data_key || '',
      type: CampaignTaskType.IG_LIVE,
    });
  });
  state.storyImages.forEach((image) => {
    result.push({
      imageKey: image.file
        ? imageKeys.shift()?.key || ''
        : image.data_key || '',
      type: CampaignTaskType.IG_STORY,
    });
  });

  state.iGPosts.forEach((item) => {
    if (item !== '') {
      result.push({
        link: item,
        type: CampaignTaskType.IG_POST,
      });
    }
  });
  state.iGReels.forEach((item) => {
    if (item !== '') {
      result.push({
        link: item,
        type: CampaignTaskType.IG_REEL,
      });
    }
  });
  state.tikToks.forEach((item) => {
    if (item !== '') {
      result.push({
        link: item,
        type: CampaignTaskType.TT_VIDEO,
      });
    }
  });
  state.twitterTweets.forEach((item) => {
    if (item !== '') {
      result.push({
        link: item,
        type: CampaignTaskType.TW_TWEET,
      });
    }
  });
  state.twitterVideos.forEach((item) => {
    if (item !== '') {
      result.push({
        link: item,
        type: CampaignTaskType.TW_VIDEO,
      });
    }
  });
  state.twitterLives.forEach((item) => {
    if (item !== '') {
      result.push({
        link: item,
        type: CampaignTaskType.TW_LIVE,
      });
    }
  });

  return result;
};

export enum SocialShareStateEnum {
  iGShare = 'iGShare',
  tTShare = 'tTShare',
  tWShare = 'tWShare',
  // fBShare = 'fBShare',
  // yTShare = 'yTShare',
}

export type SocialShareData = {
  link: string;
  images: UploadImage[];
};

export const EMPTY_SOCIAL_SHARE_STATE: SocialShareData = {
  link: '',
  images: [],
};

export type SocialShareSubmissions =
  | GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignIGShareSubmission
  | GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignTTShareSubmission
  | GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignFBShareSubmission
  | GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignTWShareSubmission
  | GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignYTShareSubmission;

export const getInitialSocialShareState = (
  record: GetCampaignOffers_getCampaignOffers_entities | null
): SocialShareData => {
  const submission = (record?.submissions as SocialShareSubmissions[])[0];

  const result: SocialShareData = {
    link: submission?.shareLink ?? '',
    images:
      submission?.shareImage && submission?.shareUrl
        ? [
            {
              data_url: submission.shareUrl,
              data_key: submission.shareImage,
              file: undefined,
            },
          ]
        : [],
  };

  return result;
};

export const getSocialShareSubmission = (
  state: SocialShareData,
  imageKeys: PresignedUrlResultItem[],
  type: CampaignTaskType
): CampaignOfferSubmissionInput[] => {
  const result: CampaignOfferSubmissionInput = {
    // no images for TikTok - only link is used
    ...(state.images?.length &&
      type !== CampaignTaskType.TT_SHARE && {
        imageKey: state.images?.[0].file
          ? imageKeys[0].key || ''
          : state.images?.[0].data_key || '',
      }),
    ...(state.link && { link: state.link }),
    type,
  };

  return [result];
};

export const getLiveAppearanceSubmission = (
  submissions: GetCampaignOffers_getCampaignOffers_entities_submissions[] | null
): GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignLiveAppearanceSubmission | null => {
  if (!submissions) {
    return null;
  }
  return submissions[0] as GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignLiveAppearanceSubmission;
};

export const getRecordedAppearanceSubmission = (
  submissions: GetCampaignOffers_getCampaignOffers_entities_submissions[] | null
): GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignRecordedAppearanceSubmission | null => {
  if (!submissions) {
    return null;
  }

  return submissions[0] as GetCampaignOffers_getCampaignOffers_entities_submissions_CampaignRecordedAppearanceSubmission;
};

export const isDeliverablesChecklistValid = (
  deliverablesChecklist: DeliverableV2[]
): boolean => {
  const hasContent = deliverablesChecklist.some(
    (d: any) => d.type === CampaignTaskType.CONTENT
  );
  const hasPost = deliverablesChecklist.some(
    (d: any) => d.type !== CampaignTaskType.CONTENT
  );
  return hasContent && hasPost;
};

export const isTimelineDeliverablesChecklistValid = (
  deliverablesChecklist: TimeLineDeliverable[]
): boolean => {
  const hasContent = deliverablesChecklist.some(
    (d: any) => d.contentItems && d.contentItems.length > 0
  );
  const hasPost = deliverablesChecklist.some(
    (d: any) => d.type !== CampaignTaskType.CONTENT
  );
  return hasContent && hasPost;
};

/**
 * UGC campaigns only require content deliverables (no post tasks).
 * Valid if there's at least one content deliverable.
 */
export const isUgcDeliverablesChecklistValid = (
  deliverablesChecklist: TimeLineDeliverable[]
): boolean => {
  if (!deliverablesChecklist.length) return false;

  return deliverablesChecklist.some(
    (d: any) =>
      d.type === CampaignTaskType.CONTENT ||
      (d.contentItems && d.contentItems.length > 0)
  );
};

export const isContentTask = (
  deliverable: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2
): boolean => {
  // Fix: Check if this deliverable has content items (files) that need to be uploaded
  const { files } = getSeparatedDeliverableItems(deliverable);
  return files.length > 0;
};

type ContentItem = {
  id: string;
  title: string;
  description: string;
  mediaType: CampaignMediaType;
  dueDate: null;
  suggestedCaption: string | null | undefined;
};

export const getContentItems = (
  deliverable: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2
): ContentItem[] => {
  const { files } = getSeparatedDeliverableItems(deliverable);
  return files.map((fileItem) => {
    const mediaType = (
      fileItem.task as GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFileItemV2_task_CampaignContentTask
    )?.mediaType;

    return {
      id: fileItem.id,
      title: fileItem.task?.title || `Content ${fileItem.id}`,
      description: fileItem.task?.description || '',
      mediaType: mediaType || CampaignMediaType.VIDEO,
      dueDate:
        'dueDate' in (deliverable.task || {})
          ? (deliverable.task as any)?.dueDate
          : null,
      suggestedCaption: deliverable.task?.suggestedCaption,
    };
  });
};

export const isCopyItem = (
  item: GetCampaignOffers_getCampaignOffers_entities_deliverables_items
): item is GetCampaignOffers_getCampaignOffers_entities_deliverables_items_CBDeliverableCopy => {
  return item.type === CBDeliverableItemType.COPY;
};

export const isFileItem = (
  item: GetCampaignOffers_getCampaignOffers_entities_deliverables_items
): item is GetCampaignOffers_getCampaignOffers_entities_deliverables_items_CBDeliverableFileItem => {
  return item.type === CBDeliverableItemType.FILE;
};

export const isFilesItem = (
  item: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items
): item is GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFilesItemV2 => {
  return item.type === CBDeliverableItemType.FILES;
};

export const getTaskSubmissions = (
  task: GetCampaignOffers_getCampaignOffers_entities_campaign_activities_SocialActivity_tasks,
  state: SocialStateType
): {
  postCopy?: string;
  files?: File[];
} | null => {
  switch (task.type) {
    case CampaignTaskType.IG_POST:
      return { postCopy: state.iGPosts[0] || '' };
    case CampaignTaskType.IG_REEL:
      return { postCopy: state.iGReels[0] || '' };
    case CampaignTaskType.TT_VIDEO:
      return { postCopy: state.tikToks[0] || '' };
    case CampaignTaskType.TW_TWEET:
      return { postCopy: state.twitterTweets[0] || '' };
    case CampaignTaskType.TW_VIDEO:
      return { postCopy: state.twitterVideos[0] || '' };
    case CampaignTaskType.TW_LIVE:
      return { postCopy: state.twitterLives[0] || '' };
    case CampaignTaskType.IG_STORY:
      return {
        files: state.storyImages
          .filter(
            (img): img is UploadImage & { file: File } => img.file !== undefined
          )
          .map((img) => img.file),
      };
    case CampaignTaskType.IG_LIVE:
      return {
        files: state.liveImages
          .filter(
            (img): img is UploadImage & { file: File } => img.file !== undefined
          )
          .map((img) => img.file),
      };
    case CampaignTaskType.CONTENT:
      // For content tasks, we need to handle this differently
      // This might need to be adjusted based on how content tasks are handled in the UI
      return { files: [] };
    default:
      return null;
  }
};

export type DeliverableTimelineCard = {
  id: string;
  title?: string;
  description?: string;
  status?: CbDeliverableV2Status;
  dueDate?: moment.Moment;
  task?: {
    id: string;
    type: CampaignTaskType;
    orderIdx?: number | null;
  };
  items?:
    | GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items[]
    | null;
};

export const checkPublishUploadAllowed = (
  deliverable: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2
): boolean => {
  return deliverable?.status === CbDeliverableV2Status.CONTENT_APPROVED;
};

export const sortDeliverablesByContentDueDate = (
  deliverables: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[]
): GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[] => {
  return deliverables
    .slice()
    .sort((a, b) => a.contentDueDateUtc - b.contentDueDateUtc);
};

export const deliverableHasContentAction = (
  status: CbDeliverableV2Status
): boolean => {
  return [
    CbDeliverableV2Status.CONTENT_REJECTED,
    CbDeliverableV2Status.TALENT_ACTION_NEEDED,
    CbDeliverableV2Status.NOT_SUBMITTED,
    CbDeliverableV2Status.ON_BRAND_REVIEW,
  ].includes(status);
};

export const deliverableHasContentFileItems = (
  deliverable: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2
): boolean => {
  return (
    deliverable.items?.some(
      (item) =>
        item.type === 'FILE' &&
        'task' in item &&
        item.task &&
        'type' in item.task &&
        item.task.type === 'CONTENT'
    ) ?? false
  );
};

/**
 * Classifies a deliverable by its task type. Mirrors the fs-web behaviour so
 * that Custom campaigns render the same content / post / appearance steps.
 *   - 'appearance' → APPEARANCE (no content/post, only a confirmation step)
 *   - 'ugc'        → UGC / CONTENT (upload content only, no posting step)
 *   - 'social'     → everything else (upload content, then publish/post)
 */
export type DeliverableKind = 'ugc' | 'social' | 'appearance';

export const getTaskKind = (
  taskType?: CampaignTaskType | null
): DeliverableKind => {
  if (taskType === CampaignTaskType.APPEARANCE) {
    return 'appearance';
  }
  if (
    taskType === CampaignTaskType.UGC ||
    taskType === CampaignTaskType.CONTENT
  ) {
    return 'ugc';
  }
  return 'social';
};

export const getDeliverableKind = (
  deliverable?: {
    task?: { type: CampaignTaskType } | null;
  } | null
): DeliverableKind => getTaskKind(deliverable?.task?.type ?? null);

export const isContentOnlyDeliverable = (
  campaignType: CampaignType | null | undefined,
  deliverable?: {
    task?: { type: CampaignTaskType } | null;
  } | null
): boolean => {
  if (campaignType === CampaignType.Ugc) return true;
  if (isCustomLikeCampaign(campaignType)) {
    return getDeliverableKind(deliverable) === 'ugc';
  }

  return false;
};

/**
 * Resolves the appearance date for an appearance deliverable. The date is
 * stored on the deliverable itself (contentDueDate*) for V3 offers.
 */
export const getAppearanceDateValue = (
  deliverable: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2
): string | null => {
  const fromDeliverable =
    deliverable.contentDueDateUtc || deliverable.contentDueDateTo;
  if (fromDeliverable) {
    return fromDeliverable;
  }

  const task = deliverable.task;
  if (
    task?.__typename === 'CampaignAppearanceTask' &&
    task.dueDate?.fixedDate
  ) {
    return task.dueDate.fixedDate;
  }

  return null;
};

/**
 * Formats an appearance date (stored in UTC) for display in the viewer's local
 * time, matching the talent-facing fs-web timeline card. Custom campaigns only.
 */
export const formatAppearanceDate = (fixedDate?: string | null): string => {
  if (!fixedDate) return 'Not set';

  return dayjs.utc(fixedDate).local().format('MMMM D, YYYY, hh:mm A');
};

/**
 * True once the appearance date/time has been reached (>=). Talent may only
 * mark an appearance complete after the scheduled appearance moment has passed.
 */
export const isAppearanceDatePassed = (fixedDate?: string | null): boolean => {
  if (!fixedDate) return false;

  return (
    dayjs.utc().isAfter(dayjs.utc(fixedDate)) ||
    dayjs.utc().isSame(dayjs.utc(fixedDate))
  );
};

export type AppearanceConfirmationItem = {
  deliverableItemId: string;
  status: CbDeliverableItemV2Status;
};

/**
 * Locates the CONFIRMATION deliverable item that belongs to an appearance
 * deliverable. Appearance deliverables carry a single CONFIRMATION item that is
 * submitted when the talent marks the appearance complete.
 */
export const getAppearanceConfirmationItem = (
  deliverable: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2
): AppearanceConfirmationItem | null => {
  const item = deliverable.items?.find(
    (i) => i.type === CBDeliverableItemType.CONFIRMATION
  );

  if (!item) return null;

  return { deliverableItemId: item.id, status: item.status };
};

/**
 * Whether the appearance confirmation has already been submitted (or approved),
 * meaning the "Mark as Complete" action should no longer be available.
 */
export const isAppearanceConfirmationSubmitted = (
  item: AppearanceConfirmationItem | null
): boolean =>
  Boolean(item) && item?.status !== CbDeliverableItemV2Status.NOT_SUBMITTED;

export const sortDeliverablesByPublishDueDate = (
  deliverables: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[]
): GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[] => {
  return deliverables.slice().sort((a, b) => {
    const dateA = a.publishDueDateUtc || a.publishDueDateTo;
    const dateB = b.publishDueDateUtc || b.publishDueDateTo;

    // If both dates are null, maintain original order
    if (!dateA && !dateB) return 0;

    // If only dateA is null, put it at the end
    if (!dateA) return 1;

    // If only dateB is null, put it at the end
    if (!dateB) return -1;

    // Both dates exist, sort normally
    return new Date(dateA).getTime() - new Date(dateB).getTime();
  });
};

export const sortDeliverablesBySubmissionStatus = (
  deliverables: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[]
): GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[] => {
  return deliverables.slice().sort((a, b) => {
    // Define status priority - submitted deliverables go to top
    const statusPriority: Record<string, number> = {
      [CbDeliverableV2Status.CONTENT_APPROVED]: 0,
      [CbDeliverableV2Status.ON_BRAND_REVIEW]: 1,
      [CbDeliverableV2Status.CONTENT_REJECTED]: 2,
      [CbDeliverableV2Status.TALENT_ACTION_NEEDED]: 3,
      [CbDeliverableV2Status.NOT_SUBMITTED]: 4,
      [CbDeliverableV2Status.PUBLISHED]: 5,
      [CbDeliverableV2Status.ARCHIVED]: 6,
    };

    const aPriority = statusPriority[a.status] ?? 999;
    const bPriority = statusPriority[b.status] ?? 999;

    // First sort by status priority
    if (aPriority !== bPriority) {
      return aPriority - bPriority;
    }

    // Then sort by contentDueDateUtc
    return a.contentDueDateUtc - b.contentDueDateUtc;
  });
};

export const sortDeliverablesByPublishStatusAndDate = (
  deliverables: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[]
): GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[] => {
  return deliverables.slice().sort((a, b) => {
    // First sort by status - published items go to top
    const aIsPublished = a.status === CbDeliverableV2Status.PUBLISHED;
    const bIsPublished = b.status === CbDeliverableV2Status.PUBLISHED;

    if (aIsPublished !== bIsPublished) {
      return aIsPublished ? -1 : 1; // Published items first
    }

    // Then sort by publish due date
    const dateA = a.publishDueDateUtc || a.publishDueDateTo;
    const dateB = b.publishDueDateUtc || b.publishDueDateTo;

    // If both dates are null, maintain original order
    if (!dateA && !dateB) return 0;

    // If only dateA is null, put it at the end
    if (!dateA) return 1;

    // If only dateB is null, put it at the end
    if (!dateB) return -1;

    // Both dates exist, sort normally
    return new Date(dateA).getTime() - new Date(dateB).getTime();
  });
};

export const getDeliverablesTimelineCards = (
  offer: GetCampaignOffers_getCampaignOffers_entities
): {
  contentDeliverables: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[];
  contentDeliverablesToShow: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[];
  publishDeliverables: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[];
  publishDeliverablesToShow: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2[];
} => {
  const sortedDeliverables = sortDeliverablesBySubmissionStatus(
    offer?.deliverablesV2 ?? []
  );

  const contentDeliverables =
    sortedDeliverables?.filter(
      (deliverable) =>
        deliverableHasContentAction(deliverable.status) ||
        deliverableHasContentFileItems(deliverable)
    ) ?? [];

  // Sort publish deliverables by status (published first) then by publish date
  const publishDeliverables = sortDeliverablesByPublishStatusAndDate(
    offer?.deliverablesV2 ?? []
  );

  const remainingSlots =
    DELIVERABLES_TIMELINE_CARDS_MAX_SLOTS - contentDeliverables.length;
  const publishDeliverablesToShow =
    remainingSlots > 0
      ? publishDeliverables
          .filter(
            (deliverable) =>
              deliverable.status !== CbDeliverableV2Status.PUBLISHED &&
              !deliverableHasContentFileItems(deliverable)
          )
          .slice(0, remainingSlots)
      : [];

  return {
    contentDeliverables: sortedDeliverables,
    contentDeliverablesToShow: contentDeliverables,
    publishDeliverables,
    publishDeliverablesToShow,
  };
};

export const getSeparatedDeliverableItems = (
  deliverable: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2
): {
  files: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFileItemV2[];
  copies: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableCopyV2[];
  filesItems: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFilesItemV2[];
} => {
  if (!deliverable?.items) {
    return { files: [], copies: [], filesItems: [] };
  }

  return {
    files: deliverable.items.filter(
      (item) => item.type === CBDeliverableItemType.FILE
    ) as GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFileItemV2[],
    copies: deliverable.items.filter(
      (item) => item.type === CBDeliverableItemType.COPY
    ) as GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableCopyV2[],
    filesItems: deliverable.items.filter(
      (item) => item.type === CBDeliverableItemType.FILES
    ) as GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFilesItemV2[],
  };
};

export const getDateLabelFromDeliverable = (
  type: 'content' | 'publish',
  deliverable?: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2 | null
): string => {
  if (!deliverable) return 'Not set';

  switch (type) {
    case 'content':
      if (deliverable.contentDueDateFrom && deliverable.contentDueDateTo) {
        return `${dayjs(deliverable.contentDueDateFrom).format(
          'MMMM D'
        )} - ${dayjs(deliverable.contentDueDateTo).format('MMMM D, YYYY')}`;
      }

      if (deliverable.contentDueDateUtc) {
        const hasFixedDate = !!(deliverable.task as any)?.dueDate?.fixedType;
        if (hasFixedDate) {
          return getDueDateLabel(deliverable.task);
        }

        return dayjs(deliverable.contentDueDateUtc).format('MMMM D, YYYY');
      }
      return 'Not set';
    case 'publish':
      if (deliverable.publishDueDateUtc) {
        return dayjs(deliverable.publishDueDateUtc).format('MMMM D, YYYY');
      }

      if (deliverable.publishDueDateFrom && deliverable.publishDueDateTo) {
        return `${dayjs(deliverable.publishDueDateFrom).format(
          'MMMM D'
        )} - ${dayjs(deliverable.publishDueDateTo).format('MMMM D, YYYY')}`;
      }

      // If nothing is set, we need to set x from approval
      if (
        (deliverable?.task as any)?.dueDate?.type ===
        CbDueDateType.CONTENT_BASED
      ) {
        return getDueDateLabel(deliverable.task);
      }
      return 'Not set';
    default:
      return 'Not set';
  }
};

export const convertIntervalDaysToValue = (intervalDays: number): number => {
  return intervalDays >= 7 ? intervalDays / 7 : intervalDays;
};

export const getDueDateLabel = (
  editingItem: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_task | null
): string => {
  if (!editingItem) return 'Not set';

  const item = editingItem as any;
  const dueDateType = item.dueDate?.type;
  const fixedDateType = item.dueDate?.fixedType;

  switch (dueDateType) {
    case CbDueDateType.CONTENT_BASED:
      if (item.dueDate?.intervalDays) {
        const totalDays = item.dueDate.intervalDays;

        // Show as weeks only if >= 7 days AND evenly divisible by 7
        if (totalDays >= 7 && totalDays % 7 === 0) {
          const weeks = totalDays / 7;
          return `${weeks} week${weeks > 1 ? 's' : ''} after content approval`;
        } else {
          return `${totalDays} day${
            totalDays > 1 ? 's' : ''
          } after content approval`;
        }
      }
      return 'After content approval';

    case CbDueDateType.FIXED:
      if (item.dueDate?.fixedDate) {
        const dateLabel = dayjs(item.dueDate?.fixedDate).format('MMMM D, YYYY');

        // Determine if it's "before" or "on" based on fixedDateType
        if (fixedDateType === CbFixedDateType.BEFORE) {
          return `Before ${dateLabel}`;
        } else if (fixedDateType === CbFixedDateType.EXACT) {
          return `On ${dateLabel}`;
        } else {
          return dateLabel;
        }
      }
      return 'Specific date not set';

    case CbDueDateType.RANGE:
      if (item.dueDate?.rangeFrom && item.dueDate?.rangeTo) {
        const fromDate = dayjs(item.dueDate?.rangeFrom);
        const toDate = dayjs(item.dueDate?.rangeTo);

        return `${fromDate.format('MMMM D')} - ${toDate.format(
          'MMMM D, YYYY'
        )}`;
      }
      return 'Date range not set';

    case CbDueDateType.APPLICATION_BASED:
      if (item.dueDate?.intervalDays) {
        const value = convertIntervalDaysToValue(item.dueDate?.intervalDays);
        const periodLabel = item.dueDate?.intervalDays >= 7 ? 'week' : 'day';
        return `${value} ${periodLabel}${
          value > 1 ? 's' : ''
        } after application approval`;
      }
      return 'After application approval';

    default:
      return 'Due date not set';
  }
};

export const getSubmissionInfo = (
  submission: GetCampaignOffers_getCampaignOffers_entities_submissions
): { label: string; link?: string; icon: string } => {
  // This would need to be implemented based on your submission types
  return {
    label: ('name' in submission
      ? (submission as { name?: string }).name || 'Unknown'
      : 'key' in submission
      ? (submission as { key?: string }).key || 'Unknown'
      : 'Unknown') as string,
    link: 'url' in submission ? submission.url : undefined,
    icon: 'file' as const,
  };
};
